import { render, staticRenderFns } from "./AverageOrderValuePage.vue?vue&type=template&id=38830046&scoped=true&"
import script from "./AverageOrderValuePage.vue?vue&type=script&lang=js&"
export * from "./AverageOrderValuePage.vue?vue&type=script&lang=js&"
import style0 from "./AverageOrderValuePage.vue?vue&type=style&index=0&id=38830046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38830046",
  null
  
)

export default component.exports